import { katTranslator } from '../../shared/i18n';

const strings = {
  "kat-expander-open": {
    "en-US": "expand",
    "ar-AE": "تمديد",
    "bn-IN": "বিস্তৃত করুন",
    "de-DE": "Erweitern",
    "es-ES": "ampliar",
    "es-MX": "ampliar",
    "fr-BE": "Développer",
    "fr-FR": "développer",
    "gu-IN": "વિસ્તાર કરો",
    "hi-IN": "विस्तार करें",
    "it-IT": "espandi",
    "ja-JP": "展開する",
    "kn-IN": "ವಿಸ್ತರಿಸಿ",
    "ko-KR": "확장",
    "ml-IN": "വികസിപ്പിക്കുക",
    "mr-IN": "विस्तारा",
    "nl-BE": "uitvouwen",
    "nl-NL": "uitvouwen",
    "pl-PL": "rozwiń",
    "pt-BR": "expandir",
    "pt-PT": "expandir",
    "sv-SE": "utöka",
    "ta-IN": "விரி",
    "te-IN": "విస్తరించండి",
    "th-TH": "ขยาย",
    "tr-TR": "genişlet",
    "vi-VN": "mở rộng",
    "zh-CN": "展开",
    "zh-TW": "展開"
  },
  "kat-expander-close": {
    "en-US": "collapse",
    "ar-AE": "طي",
    "bn-IN": "বন্ধ করুন",
    "de-DE": "Ausblenden",
    "es-ES": "plegar",
    "es-MX": "contraer",
    "fr-BE": "Masquer",
    "fr-FR": "réduire",
    "gu-IN": "કોલેપ્સ",
    "hi-IN": "कम दिखाएं",
    "it-IT": "riduci",
    "ja-JP": "折りたたむ",
    "kn-IN": "ಕುಗ್ಗಿಸಿ",
    "ko-KR": "축소",
    "ml-IN": "ചുരുക്കുക",
    "mr-IN": "संकुचित करा",
    "nl-BE": "samenvouwen",
    "nl-NL": "samenvouwen",
    "pl-PL": "zwiń",
    "pt-BR": "recolher",
    "pt-PT": "fechar",
    "sv-SE": "dölj",
    "ta-IN": "சுருக்கு",
    "te-IN": "కుదించండి",
    "th-TH": "ยุบ",
    "tr-TR": "daralt",
    "vi-VN": "thu gọn",
    "zh-CN": "折叠",
    "zh-TW": "收合"
  }
}; 

export default katTranslator(strings);
    